import { render, staticRenderFns } from "./restaurant-empty.vue?vue&type=template&id=0634f504&scoped=true"
import script from "./restaurant-empty.vue?vue&type=script&lang=js"
export * from "./restaurant-empty.vue?vue&type=script&lang=js"
import style0 from "./restaurant-empty.vue?vue&type=style&index=0&id=0634f504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0634f504",
  null
  
)

export default component.exports